export const createGamePauseSlice = ({ togglePause })=>(set, get)=>({
            gamePause: {
                isPaused: false,
                setIsPaused: (isPaused)=>{
                    set({
                        gamePause: {
                            ...get().gamePause,
                            isPaused: isPaused
                        }
                    });
                },
                remainingPauseTimeMS: undefined,
                setRemainingPauseTimeMS: (remainingPauseTimeMS)=>{
                    set({
                        gamePause: {
                            ...get().gamePause,
                            remainingPauseTimeMS: remainingPauseTimeMS
                        }
                    });
                },
                togglePause: togglePause
            }
        });
